<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">UM PP Form {{mode === 'Create' ? 'Create' : 'Revision'}}</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Detail" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <keep-alive>
        <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
      </keep-alive>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next">Next</a-button>
        <a-button
          :loading="btnLoading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
        >Save</a-button>
        <a-button v-if="current>0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Informasi from "./steps/Informasi.vue";
import Detail from "./steps/Detail.vue";
import Approval from "./steps/Persetujuan.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
export default {
  name: "UMPPCreate",
  props: ["id"],
  mixins: [CurrencyFormat],
  components: {
    Informasi,
    Detail,
    Approval,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi"
        },
        {
          title: "Detail",
          content: "Detail"
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      mode: "Create",
      collectData: {
        informasi: {}
      },
      mata_uang: "",
      listUMPP: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      limitRevisi: 0,
      kurs: 0,
      btnLoading: false
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    initialListItem() {
      let data = [];
      let hargaTotal = 0;
      if (this.mode === "Edit") {
        this.listUMPP.forEach(item => {
          hargaTotal = item.values.jumlah * item.values.harga;
          const values = item.values;
          data = [...data, { hargaTotal: hargaTotal, values }];
        });
      } else {
        data = this.listUMPP;
        this.collectData.listUMPP.forEach(item => {
          hargaTotal = item.jumlah * item.harga;
          data = [
            ...data,
            {
              hargaTotal: hargaTotal,
              values: item
            }
          ];
        });
      }
      return data;
    },
    stepProps: function() {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            id: this.id,
            data: this.collectData.informasi,
            listUMPP: this.listUMPP,
            mode: this.mode,
            mata_uang: this.mata_uang,
          };
        } else if (this.steps[this.current].content === "Detail") {
          return {
            id: this.id,
            data: this.collectData.informasi,
            listUMPP: this.listUMPP,
            mode: "Edit",
            mata_uang: this.mata_uang,
            limitRevisi: this.limitRevisi.toString(),
            kurs: this.kurs.toString(),
          };
        } else if (this.steps[this.current].content === "Approval") {
          return {
            collectData: this.collectData,
            mode: this.mode,
            listAppr: this.collectData.approval,
            id: this.id
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            mode: this.mode,
            listUMPP: this.listUMPP,
            mata_uang: this.mata_uang,
          };
        } else if (this.steps[this.current].content === "Detail") {
          return {
            data: this.collectData.informasi,
            listUMPP: this.listUMPP,
            mode: this.mode,
            mata_uang: this.mata_uang,
            kurs: this.kurs,
          };
        } else if (this.steps[this.current].content === "Approval") {
          return {
            collectData: this.collectData,
            mode: this.mode,
            listAppr: this.collectData.approval,
            id: this.id
          };
        }
      }
      return true
    },
    stepRef: function() {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "Detail") {
        return "refDetail";
      }else {
        return "refApproval";
      }
    }
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchDetail();
    }
  },
  methods: {
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "Detail") {
        this.$refs.refDetail.handleRef();
      } else {
        this.$refs.refApproval.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      this.$refs.refApproval.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        if (this.mode === "Create") {
          this.collectData.informasi = JSON.parse(
            JSON.stringify(value.informasi)
          );
          //this.collectData.listUMPP = JSON.parse(JSON.stringify(value.listUMPP));
          this.kurs = this.collectData.informasi.kurs;
          this.mata_uang = this.collectData.informasi.currency;
        } else {
            this.collectData.informasi = JSON.parse(
              JSON.stringify(value.informasi)
            );

          if (this.collectData.listUMPP === "undefined") {
            this.collectData.listUMPP = JSON.parse(JSON.stringify(value.listUMPP));
          }
        }

        //this.mata_uang = value.mata_uang;

        this.current++;
      } else if (this.steps[this.current].content === "Detail") {
        // if (this.mode=="Edit"){
        //   let flagSave = parseFloat(this.limitRevisi)>=50000000
        //   let flagnom = value.grandtotal*parseFloat(this.kurs)>=50000000
        //   if(flagSave!==flagnom){
        //     flagSave 
        //     ? this.displayMessageValue("error-other", "Grand Total of modified data must not be less than Rp.50.000.000!")
        //     : this.displayMessageValue("error-other", "Grand Total of modified data should not be more than Rp.50.000.000!")
        //     return
        //   }
        // }

        this.collectData.listUMPP = JSON.parse(JSON.stringify(value.Detail));
        this.collectData.grandtotal = value.grandtotal;
        this.getApproval();
      } else if (this.steps[this.current].content === "Approval") {
        this.collectData.informasi.catatan = value.note;
        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      }
    },
    getlistUMPP(item) {
      this.listUMPP = [...this.listUMPP, JSON.parse(JSON.stringify(item.values))];
      this.$refs.refDetail.recountingBalance(this.listUMPP)
    },
    getUpdatelistUMPP(item) {
      this.listUMPP = item;
      this.$refs.refDetail.recountingBalance(this.listUMPP)
    },
    setSubmitForm() {
      if (this.mode === "Edit") {

        let pp_dtl = [];
        let item_name = [];
        let value = [];
        let id_um_dtl = []

        this.collectData.listUMPP.forEach(data => {
            pp_dtl.push(data.selectedPPdtl),
            item_name.push(data.item_name),
            value.push(data.value);
            id_um_dtl.push(data.id_um_dtl);
        });

        this.postJson = {
          tlc: this.getAuth.username,
          id_manifest: this.collectData.informasi.id_manifest,
          deskripsi: this.collectData.informasi.deskripsi,
          end_user: this.collectData.informasi.end_user,
          catatan: this.collectData.informasi.catatan,
          
          pp_dtl: pp_dtl,
          item_name: item_name,
          value: value,
          id_um_dtl: id_um_dtl,
        };
      } else {
        this.postData = new FormData();
          this.postData.append("tlc", this.getAuth.username);
          this.postData.append("no_pp", this.collectData.informasi.no_pp);
          this.postData.append(
            "tanggal",
            moment(this.collectData.informasi.tanggal).format(this.defaultFormat)
          );
          this.postData.append("deskripsi", this.collectData.informasi.deskripsi);
          this.postData.append("end_user", this.collectData.informasi.end_user);
          this.postData.append("catatan", this.collectData.informasi.catatan !==undefined ? this.collectData.informasi.catatan : "");

          this.collectData.listUMPP.forEach((data) => {
          this.postData.append("pp_dtl[]", data.selectedPPdtl);
          this.postData.append("item_name[]", data.item_name);
          this.postData.append("value[]", data.value);
        });
      }
    },
    submit() {
      this.setSubmitForm();
      this.btnLoading = true;
      let method = "";
      let data;
      let urlVal = "";

      if (this.mode === "Create") {
        method = "post";
        data = this.postData;
        urlVal = "um_pp/v2";
      } else {
        method = "put";
        data = this.postJson;
        urlVal = "um_pp/v2";
      }

      // for (var pair of this.postData.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }

      axios({
        method: method,
        url: this.$serviceUrl + urlVal,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          if (this.mode === "Create") {
            if (response.data.message === "Has been created") {
              this.displayMessage("success-save");
            } else if (
              response.data.message === "transaksi tak memiliki work flow"
            ) {
              this.displayMessage("error-ppproyek");
            } else if (response.data.message === "Saldo PP tidak cukup!") {
              this.displayMessage("error-saldopp");
            }
          } else {
            this.displayMessage("success-edit");
          }
          this.btnLoading = false;
          this.current = 0;
          this.$destroy();
          this.$router.go(-1);
        })
        .catch(err => {
          this.btnLoading = false;
            let responses = Object.assign({}, err.response.data);
          if (responses.message === "Saldo PP tidak cukup!") {
              let sisa = this.formatCurrency(
                  this.mata_uang,
                  responses.saldo
              );
              this.displayMessageValue("pp-notenough",sisa);
          } else if(responses.message){
            this.displayMessageValue("error-other",responses.message);
          } else {
            this.displayMessageValue("error", responses);
          }
        });
    },
    fetchDetail() {
      axios({
        method: "get",
        url: this.$serviceUrl + "um_pp/um_pp_Detil_v2",
        params: {
          id_manifest: this.id,
          tlc: this.getAuth.username
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.informasi = response.data.detail_um_pp[0];
          this.collectData.informasi.id_manifest = this.id;
          this.collectData.informasi.end_user = response.data.detail_um_pp[0].end_user;
          this.listUMPP = response.data.dtl_um;
          this.mata_uang = response.data.detail_um_pp[0].mata_uang

          if(this.mode=="Edit")
          this.kurs = response.data.detail_um_pp[0].kurs
          this.limitRevisi = parseFloat(response.data.detail_um_pp[0].kurs) * 
            parseFloat(response.data.detail_um_pp[0].estimate_value)
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
    async getApproval(){
      let params = null;
      if (this.mode=="Create"){
        params = {
          no_pp : this.collectData.informasi.no_pp,
          value : this.collectData.grandtotal,
        }
      }else{
        params = {
          no_pp : this.collectData.informasi.no_pp,
          value : this.collectData.grandtotal,
          id_um : this.collectData.listUMPP[0].id_um,
        }
      }
      await axios({
        method: 'get',
        url: this.$serviceUrl + "um_pp/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval=response.data.data;
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    }
  },
  mounted() {
    Event.$on("umppData", this.valueFromChild);
    Event.$on("listUMPP", this.getlistUMPP);
    Event.$on("updateList", this.getUpdatelistUMPP);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("umppData", this.valueFromChild);
    Event.$off("listUMPP", this.getlistUMPP);
    Event.$off("updateList", this.getUpdatelistUMPP);
    Event.$off("confirmMessageReturn", this.submit);
  }
}
</script>